<template>
  <div class="terminal-page">
    <!-- Tabs：用户列表 + 通知列表 -->
    <el-tabs v-model="activeName" type="border-card" style="width: 100%; height: 100%;">
      <el-tab-pane label="用户列表" name="first">
        <div class="main_r">
          <div class="page-top">
            <div class="title_line">终端用户</div>

            <!-- 筛选 -->
            <div class="filter-strip">
              <div class="filter-strip__fields">
                <div class="filter-field filter-field--compact">
                  <label class="filter-field__label">账号</label>
                  <el-input v-model="queryData.account" placeholder="请输入账号" clearable size="small"></el-input>
                </div>
                <div class="filter-field filter-field--compact">
                  <label class="filter-field__label">昵称</label>
                  <el-input v-model="queryData.nickName" placeholder="请输入昵称" clearable size="small"></el-input>
                </div>
                <div class="filter-field filter-field--compact">
                  <label class="filter-field__label">口号</label>
                  <el-input v-model="queryData.slogan" placeholder="请输入口号" clearable size="small"></el-input>
                </div>
                <div class="filter-field filter-field--compact">
                  <label class="filter-field__label">性别</label>
                  <el-select v-model="queryData.sex" placeholder="请选择性别" size="small">
                    <el-option label="请选择性别" value="0"></el-option>
                    <el-option label="男" value="1"></el-option>
                    <el-option label="女" value="2"></el-option>
                    <el-option label="保密" value="3"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="filter-strip__actions">
                <el-button type="primary" size="small" icon="el-icon-search" @click="clickQuery">查询</el-button>
                <el-button type="primary" size="small" plain icon="el-icon-refresh-left" @click="clickQueryReset">重置</el-button>
                <span class="filter-strip__sep"></span>
                <el-button type="primary" size="small" icon="el-icon-message" @click="clickNoticeSelect">通知勾选用户</el-button>
                <el-button type="primary" size="small" icon="el-icon-bell" @click="clickNoticeAll">通知所有用户</el-button>
              </div>
            </div>
          </div>

          <!-- 列表 -->
          <div class="table-section" ref="tableSection">
            <div class="table-container" ref="tableContainer">
              <el-table
                :data="dataList"
                class="user-table"
                :height="tableHeight"
                :header-cell-style="tableHeaderStyle"
                :cell-style="tableCellStyle"
                @selection-change="handleSelectionChange"
                @sort-change="handleSortChange">
                <el-table-column type="selection" width="55" align="center" fixed="left"></el-table-column>
                <el-table-column prop="id" label="序号" width="80" sortable="custom" align="center" fixed="left"></el-table-column>
                <el-table-column prop="account" label="账号" min-width="140" sortable="custom" show-overflow-tooltip></el-table-column>
                <el-table-column prop="nickName" label="昵称" min-width="140" sortable="custom" show-overflow-tooltip></el-table-column>
                <el-table-column prop="" label="微信头像" width="100" align="center">
                  <template v-slot="scope">
                    <img :src="scope.row.headimgurl" width="48" height="48" style="border-radius: var(--radius-md); object-fit: cover; box-shadow: var(--shadow-sm);" />
                  </template>
                </el-table-column>
                <el-table-column prop="deviceSn" label="设备识别码" min-width="150" sortable="custom" show-overflow-tooltip>
                  <template slot-scope="props">
                    <span>{{ props.row.deviceSn || '--' }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="userStatus" label="状态" width="100" sortable="custom" align="center">
                  <template slot-scope="props">
                    <el-tag :type="props.row.userStatus == 0 ? 'danger' : 'success'" size="small" effect="plain">
                      {{ props.row.userStatus == 0 ? '已冻结' : '正常' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="lastLoginTime" label="最后登录时间" min-width="170" sortable="custom" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createTime" label="创建时间" min-width="170" sortable="custom" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Operation" label="操作" width="220" fixed="right" align="center">
                  <template slot-scope="props">
                    <div class="action-group">
                      <el-tooltip effect="dark" content="编辑" placement="top" :enterable="false">
                        <el-link :underline="false" type="primary" icon="el-icon-edit" @click="clickdialogEdit(props.row)"></el-link>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="体脂秤数据" placement="top" :enterable="false">
                        <el-link :underline="false" type="primary" icon="el-icon-odometer" @click="openBodyFatDialog(props.row)"></el-link>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="训练报告" placement="top" :enterable="false">
                        <el-link :underline="false" type="primary" icon="el-icon-s-data" @click="openTrainReportDialog(props.row)"></el-link>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="我的训练计划" placement="top" :enterable="false">
                        <el-link :underline="false" type="primary" icon="el-icon-s-check" @click="openTrainPlanDialog(props.row)"></el-link>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="通知单个用户" placement="top" :enterable="false">
                        <el-link :underline="false" type="warning" icon="el-icon-notebook-2" @click="clickdialogNotice(props.row)"></el-link>
                      </el-tooltip>
                      <el-tooltip v-if="props.row.userStatus == 1" effect="dark" content="冻结" placement="top" :enterable="false">
                        <el-link :underline="false" type="danger" icon="el-icon-lock" @click="clickFreezeUser(props.row)"></el-link>
                      </el-tooltip>
                      <el-tooltip v-if="props.row.userStatus == 0" effect="dark" content="解冻" placement="top" :enterable="false">
                        <el-link :underline="false" type="success" icon="el-icon-unlock" @click="clickUnfreezeUser(props.row)"></el-link>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <!-- 分页 -->
          <div class="pagination-wrapper">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page_no"
              :page-sizes="[5, 10, 15, 20]"
              :page-size="page_size"
              layout="total, prev, pager, next, sizes, jumper"
              :total="dataListnum">
            </el-pagination>
          </div>
        </div>

        <!-- 编辑信息 -->
        <el-dialog title="编辑信息" :visible.sync="dialogEdit" width="40%" top="5vh" center class="newAdd">
          <div class="addUser_body">
            <el-form ref="userMsg" :model="editData" label-width="100px">
              <el-form-item label="昵称">
                <el-input v-model="editData.nickName" placeholder="请输入昵称"></el-input>
              </el-form-item>
              <el-form-item label="微信头像" :required=true>
                <el-input v-model="editData.headimgurl" placeholder="请输入微信头像"></el-input>
              </el-form-item>
              <el-form-item label="身高" :required=true>
                <el-input v-model="editData.height" placeholder="请输入身高">
                  <template slot="append"><span class="input-unit">cm</span></template>
                </el-input>
              </el-form-item>
              <el-form-item label="体重" :required=true>
                <el-input v-model="editData.weight" placeholder="请输入体重">
                  <template slot="append"><span class="input-unit">Kg</span></template>
                </el-input>
              </el-form-item>
              <el-form-item label="年龄" :required=true>
                <el-input v-model="editData.age" placeholder="请输入年龄">
                  <template slot="append"><span class="input-unit">岁</span></template>
                </el-input>
              </el-form-item>
              <el-form-item label="性别">
                <el-select v-model="editData.sex" placeholder="性别">
                  <el-option label="男" value="1"></el-option>
                  <el-option label="女" value="2"></el-option>
                  <el-option label="保密" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="生日" :required=true>
                <el-date-picker v-model="editData.birthday" type="date" value-format="yyyy-MM-dd" placeholder="请选择生日" style="width: 100%;"></el-date-picker>
              </el-form-item>
              <el-form-item label="口号" :required=true>
                <el-input v-model="editData.slogan" placeholder="请输入口号"></el-input>
              </el-form-item>
              <el-form-item label="腰围">
                <el-input v-model="editData.waist" placeholder="请输入腰围" type="number">
                  <template slot="append"><span class="input-unit">cm</span></template>
                </el-input>
              </el-form-item>
              <el-form-item label="训练时长">
                <el-select v-model="editData.trainingDuration" placeholder="请选择力量训练时长" clearable>
                  <el-option label="未填写" :value="0"></el-option>
                  <el-option label="新手（<2月）" :value="1"></el-option>
                  <el-option label="入门（3-6月）" :value="2"></el-option>
                  <el-option label="熟练（6-12年）" :value="3"></el-option>
                  <el-option label="进阶（>2年）" :value="4"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="每周次数">
                <el-select v-model="editData.weeklyFrequency" placeholder="请选择每周训练次数" clearable>
                  <el-option label="未填写" :value="0"></el-option>
                  <el-option label="低频（1-2次）" :value="1"></el-option>
                  <el-option label="常规（3-4次）" :value="2"></el-option>
                  <el-option label="高频（5+次）" :value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="每周强度">
                <el-select v-model="editData.weeklyIntensity" placeholder="请选择每周训练强度" clearable>
                  <el-option label="未填写" :value="0"></el-option>
                  <el-option label="低强度" :value="1"></el-option>
                  <el-option label="中强度" :value="2"></el-option>
                  <el-option label="高强度" :value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="技术熟练度">
                <el-select v-model="editData.skillLevel" placeholder="请选择技术熟练度" clearable>
                  <el-option label="未填写" :value="0"></el-option>
                  <el-option label="无基础" :value="1"></el-option>
                  <el-option label="基础" :value="2"></el-option>
                  <el-option label="熟练" :value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="状态" :required="true">
                <el-select v-model="editData.userStatus" placeholder="请选择状态">
                  <el-option label="正常" value="1"></el-option>
                  <el-option label="冻结" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="TerminalUserEdit()" >确定</el-button>
            <el-button @click="dialogEdit = false">取消</el-button>
          </div>
        </el-dialog>
        <!-- 编辑信息 End -->
      </el-tab-pane>

      <!-- 通知列表 start -->
      <el-tab-pane label="通知列表" name="five">
        <WebTwoNoticeNeedRead></WebTwoNoticeNeedRead>
      </el-tab-pane>
      <!-- 通知列表 end -->
    </el-tabs>
    <!-- Tabs end -->

    <!-- ====== 详情弹窗 ====== -->

    <!-- 体脂秤数据 -->
    <el-dialog
      :title="'体脂秤数据 - ' + (currentUser.nickName || '')"
      :visible.sync="dialogBodyFat"
      width="90%"
      top="5vh"
      class="newAdd detail-dialog"
      :close-on-click-modal="false"
      @closed="onDetailDialogClosed">
      <WebBodyFatScalesLog v-if="dialogBodyFat" ref="SubVuefour"></WebBodyFatScalesLog>
    </el-dialog>

    <!-- 训练报告 -->
    <el-dialog
      :title="'训练报告 - ' + (currentUser.nickName || '')"
      :visible.sync="dialogTrainReport"
      width="90%"
      top="5vh"
      class="newAdd detail-dialog"
      :close-on-click-modal="false"
      @closed="onDetailDialogClosed">
      <WebTwoTrainReport v-if="dialogTrainReport" ref="SubVuesix"></WebTwoTrainReport>
    </el-dialog>

    <!-- 我的训练计划 -->
    <el-dialog
      :title="'我的训练计划 - ' + (currentUser.nickName || '')"
      :visible.sync="dialogTrainPlan"
      width="90%"
      top="5vh"
      class="newAdd detail-dialog"
      :close-on-click-modal="false"
      @closed="onDetailDialogClosed">
      <WebTwoTrainPlanMy v-if="dialogTrainPlan" ref="SubVueseven"></WebTwoTrainPlanMy>
    </el-dialog>

    <!-- 发送通知 -->
    <el-dialog :title="dialogNoticeTitle" :visible.sync="dialogNotice" width="80%" class="newAdd">
      <div class="main_r">
        <!-- 筛选 -->
        <div class="filter-strip">
          <div class="filter-strip__fields">
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">消息类型</label>
              <el-select v-model="queryDataNotice.noticeType" placeholder="消息类型" size="small">
                <el-option label="请选择消息类型" value="0"></el-option>
                <el-option label="系统消息" value="1"></el-option>
                <el-option label="活动消息" value="2"></el-option>
              </el-select>
            </div>
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">消息标题</label>
              <el-input v-model="queryDataNotice.noticeTitle" placeholder="请输入消息标题" clearable size="small"></el-input>
            </div>
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">消息内容</label>
              <el-input v-model="queryDataNotice.noticeContent" placeholder="请输入消息内容" clearable size="small"></el-input>
            </div>
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">起始时间</label>
              <el-date-picker v-model="queryDataNotice.timeBegin" type="date" value-format="yyyy-MM-dd" placeholder="起始时间" size="small"></el-date-picker>
            </div>
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">结束时间</label>
              <el-date-picker v-model="queryDataNotice.timeEnd" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" size="small"></el-date-picker>
            </div>
          </div>
          <div class="filter-strip__actions">
            <el-button type="primary" size="small" icon="el-icon-search" @click="clickQueryNotice">查询</el-button>
          </div>
        </div>
        <!-- 筛选 End -->

        <!-- 列表 -->
        <div class="table-section">
          <div class="table-container">
            <el-table
              :data="dataListNotice"
              class="user-table"
              :header-cell-style="tableHeaderStyle"
              :cell-style="tableCellStyle"
              @sort-change="handleSortChangeNotice">
              <el-table-column prop="id" label="序号" width="80" sortable="custom" align="center"></el-table-column>
              <el-table-column prop="noticeType" label="消息类型" width="120" sortable="custom" align="center">
                <template slot-scope="props">
                  <el-tag :type="props.row.noticeType == 1 ? 'primary' : 'warning'" size="small" effect="plain">
                    {{ props.row.noticeType == 1 ? '系统消息' : '活动消息' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="noticeTitle" label="消息标题" min-width="180" sortable="custom" show-overflow-tooltip></el-table-column>
              <el-table-column prop="noticeContent" label="消息内容" min-width="280" sortable="custom" show-overflow-tooltip></el-table-column>
              <el-table-column prop="createTime" label="创建时间" min-width="170" sortable="custom" show-overflow-tooltip></el-table-column>
              <el-table-column prop="Operation" label="操作" width="100" align="center" fixed="right">
                <template slot-scope="scope">
                  <div class="action-group">
                    <el-tooltip effect="dark" content="发送" placement="top" :enterable="false">
                      <el-link :underline="false" type="danger" icon="el-icon-s-promotion" @click="ClickSendNotice(scope.row)"></el-link>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!-- 分页 -->
        <div class="pagination-wrapper">
          <el-pagination
            @size-change="handleSizeChangeNotice"
            @current-change="handleCurrentChangeNotice"
            :current-page="page_noNotice"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="page_sizeNotice"
            layout="total, prev, pager, next, sizes, jumper"
            :total="dataListNoticenum">
          </el-pagination>
        </div>
        <!-- 分页 End -->
      </div>
    </el-dialog>
    <!-- 发送通知 End -->
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import WebBodyFatScalesLog from '@/componentsSubVue/WebBodyFatScalesLog.vue'
import WebTwoTrainReport from '@/componentsSubVue/WebTwoTrainReport.vue'
import WebTwoTrainPlanMy from '@/componentsSubVue/WebTwoTrainPlanMy.vue'
import WebTwoNoticeNeedRead from '@/componentsSubVue/WebTwoNoticeNeedRead.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    WebBodyFatScalesLog,
    WebTwoTrainReport,
    WebTwoTrainPlanMy,
    WebTwoNoticeNeedRead
  },
  data () {
    return {
      activeName: 'first',
      formLabelWidth: '120px',
      queryData: {
        account: '',
        nickName: '',
        slogan: '',
        sex: '0'
      },
      // 用户列表
      dataList: [],
      dataListnum: 0,
      tableHeight: 480,
      page_no: 1,
      page_size: 10,
      sortField: '',
      sortOrder: '',
      // 编辑
      dialogEdit: false,
      editData: {
        editId: '',
        nickName: '',
        headimgurl: '',
        height: '',
        weight: '',
        age: '',
        sex: '',
        birthday: '',
        slogan: '',
        userStatus: '1',
        waist: '',
        trainingDuration: 0,
        weeklyFrequency: 0,
        weeklyIntensity: 0,
        skillLevel: 0
      },
      // 当前选中用户（详情弹窗用）
      currentUser: {},
      // 详情弹窗
      dialogBodyFat: false,
      dialogTrainReport: false,
      dialogTrainPlan: false,
      // 通知
      dialogNotice: false,
      noticeData: {
        userid: '',
        noticeId: ''
      },
      multipleSelection: [],
      dialogNoticeTitle:'通知单个用户',
      queryDataNotice: {
        noticeType: '0',
        noticeTitle: '',
        noticeContent: '',
        timeBegin: '',
        timeEnd: ''
      },
      dataListNotice: [],
      dataListNoticenum: 0,
      page_noNotice: 1,
      page_sizeNotice: 5,
      sortFieldNotice: '',
      sortOrderNotice: '',
    }
  },
  mounted () {
    this.TerminalUserList()
    this.TerminalUserNum()
    this.NoticeList()
    this.NoticeNum()
    window.addEventListener('resize', this.onWindowResize)
    this.$nextTick(this.initTableResizeObserver)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onWindowResize)
    this.destroyTableResizeObserver()
  },
  methods: {
    tableHeaderStyle () {
      return { textAlign: 'center', background: 'var(--aptus-surface-muted)', color: 'var(--aptus-text-secondary)', fontWeight: '600' }
    },
    tableCellStyle ({ column }) {
      if (column.type === 'selection' || column.property === 'Operation' || column.property === 'userStatus' || column.property === 'id' || column.property === 'noticeType' || column.property === 'headimgurl') {
        return { textAlign: 'center' }
      }
      return { textAlign: 'left' }
    },
    // ====== 表格高度 ======
    calcTableHeight () {
      var that = this
      this.$nextTick(function () {
        var container = that.$refs.tableContainer
        if (!container) return
        var height = container.clientHeight
        if (height > 0) {
          that.tableHeight = Math.max(240, Math.floor(height))
        }
      })
    },
    initTableResizeObserver () {
      var that = this
      this.calcTableHeight()
      if (typeof ResizeObserver === 'undefined') return
      this.tableResizeObserver = new ResizeObserver(function () {
        that.calcTableHeight()
      })
      if (this.$refs.tableContainer) {
        this.tableResizeObserver.observe(this.$refs.tableContainer)
      }
    },
    destroyTableResizeObserver () {
      if (this.tableResizeObserver) {
        this.tableResizeObserver.disconnect()
        this.tableResizeObserver = null
      }
    },
    onWindowResize () {
      this.calcTableHeight()
    },
    // ====== 详情弹窗 ======
    openBodyFatDialog (row) {
      this.currentUser = row
      this.dialogBodyFat = true
      this.$nextTick(() => {
        this.$refs.SubVuefour && this.$refs.SubVuefour.LoadData(row)
      })
    },
    openTrainReportDialog (row) {
      this.currentUser = row
      this.dialogTrainReport = true
      this.$nextTick(() => {
        this.$refs.SubVuesix && this.$refs.SubVuesix.LoadData(row)
      })
    },
    openTrainPlanDialog (row) {
      this.currentUser = row
      this.dialogTrainPlan = true
      this.$nextTick(() => {
        this.$refs.SubVueseven && this.$refs.SubVueseven.LoadData(row)
      })
    },
    onDetailDialogClosed () {
      this.currentUser = {}
    },
    // ====== 分页 & 排序 ======
    handleSizeChange (val) {
      this.page_size = val
      this.TerminalUserList()
      this.TerminalUserNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.TerminalUserList()
      this.TerminalUserNum()
    },
    handleSortChange ({ prop, order }) {
      this.sortField = prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.page_no = 1
      this.TerminalUserList()
      this.TerminalUserNum()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection)
    },
    clickQuery () {
      this.page_no = 1
      this.TerminalUserList()
      this.TerminalUserNum()
    },
    clickQueryReset () {
      this.queryData.account = ''
      this.queryData.nickName = ''
      this.queryData.slogan = ''
      this.queryData.sex = '0'
      this.clickQuery()
    },
    clickNoticeSelect(){
      var useridList = []
      for (let element of this.multipleSelection) {
        useridList.push(element.id)
      }
      var userid = useridList.join(';');
      if(userid == ''){
        this.$message.warning('请至少勾选1个终端用户');
        return;
      }
      this.dialogNotice = true
      this.dialogNoticeTitle = '通知勾选用户'
      this.noticeData.userid = userid
      this.noticeData.noticeId = ''
    },
    clickNoticeAll(){
      this.dialogNotice = true
      this.dialogNoticeTitle = '通知所有用户'
      this.noticeData.userid = '0'
      this.noticeData.noticeId = ''
    },
    clickdialogNotice (row) {
      this.dialogNotice = true
      this.dialogNoticeTitle = '通知单个用户'
      this.noticeData.userid = row.id
      this.noticeData.noticeId = ''
    },
    clickdialogEdit (row) {
      this.dialogEdit = true
      this.editData.editId = row.id
      this.editData.nickName = row.nickName
      this.editData.headimgurl = row.headimgurl
      this.editData.height = row.height
      this.editData.weight = row.weight
      this.editData.age = row.age
      this.editData.sex = row.sex.toString()
      this.editData.birthday = row.birthday
      this.editData.slogan = row.slogan
      this.editData.userStatus = row.userStatus != null ? row.userStatus.toString() : '1'
      this.editData.waist = row.waist || ''
      this.editData.trainingDuration = row.trainingDuration || 0
      this.editData.weeklyFrequency = row.weeklyFrequency || 0
      this.editData.weeklyIntensity = row.weeklyIntensity || 0
      this.editData.skillLevel = row.skillLevel || 0
    },
    // ====== 通知列表 ======
    handleSizeChangeNotice (val) {
      this.page_sizeNotice = val
      this.NoticeList()
      this.NoticeNum()
    },
    handleCurrentChangeNotice (val) {
      this.page_noNotice = val
      this.NoticeList()
      this.NoticeNum()
    },
    handleSortChangeNotice ({ prop, order }) {
      this.sortFieldNotice = prop || ''
      this.sortOrderNotice = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.page_noNotice = 1
      this.NoticeList()
      this.NoticeNum()
    },
    clickQueryNotice () {
      this.page_noNotice = 1
      this.NoticeList()
      this.NoticeNum()
    },
    ClickSendNotice(row){
      this.$deleteConfirm('是否确定发送此消息?').then(() => {
        this.noticeData.noticeId = row.id
        this.NoticeNeedReadInsert()
      })
    },
    // ====== API ======
    TerminalUserList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.account = that.queryData.account
      data.nickName = that.queryData.nickName
      data.slogan = that.queryData.slogan
      data.sex = that.queryData.sex
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TerminalUserList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
          that.calcTableHeight()
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    TerminalUserNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.account = that.queryData.account
      data.nickName = that.queryData.nickName
      data.slogan = that.queryData.slogan
      data.sex = that.queryData.sex
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TerminalUserNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    TerminalUserEdit: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.editId = that.editData.editId
      data.nickName = that.editData.nickName
      data.headimgurl = that.editData.headimgurl
      data.height = that.editData.height
      data.weight = that.editData.weight
      data.age = that.editData.age
      data.sex = that.editData.sex
      data.birthday = that.editData.birthday
      data.slogan = that.editData.slogan
      data.waist = that.editData.waist
      data.trainingDuration = that.editData.trainingDuration
      data.weeklyFrequency = that.editData.weeklyFrequency
      data.weeklyIntensity = that.editData.weeklyIntensity
      data.skillLevel = that.editData.skillLevel
      data.userStatus = that.editData.userStatus
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TerminalUserEdit, Qs.stringify(data))
        .then(function (response) {
          that.dialogEdit = false
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.TerminalUserList()
            that.TerminalUserNum()
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogEdit = false
        })
    },
    clickFreezeUser: function (row) {
      var that = this
      this.$deleteConfirm('确定冻结该用户？冻结后用户将无法登录且当前会话会被踢出').then(function () {
        that.TerminalUserFreeze(row.id, 0)
      }).catch(function () {})
    },
    clickUnfreezeUser: function (row) {
      var that = this
      this.$deleteConfirm('确定解冻该用户？').then(function () {
        that.TerminalUserFreeze(row.id, 1)
      }).catch(function () {})
    },
    TerminalUserFreeze: function (userId, userStatus) {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.userId = userId
      data.userStatus = userStatus
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TerminalUserFreeze, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            Vue.prototype.$message.success(userStatus === 0 ? '冻结成功' : '解冻成功')
            that.TerminalUserList()
          } else {
            Vue.prototype.FunRemindAllways(response.data.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    NoticeNeedReadInsert: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.userid = that.noticeData.userid
      data.noticeId = that.noticeData.noticeId
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_NoticeNeedReadInsert, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            Vue.prototype.$message.success(response.data.msg || '发送成功')
          } else {
            Vue.prototype.$message.warning(response.data.msg || '发送失败')
          }
        })
        .catch(function (error) {
          console.log(error)
          Vue.prototype.$message.error('发送失败')
        })
    },
    NoticeList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.noticeType = that.queryDataNotice.noticeType
      data.noticeTitle = that.queryDataNotice.noticeTitle
      data.noticeContent = that.queryDataNotice.noticeContent
      data.timeBegin = that.queryDataNotice.timeBegin
      data.timeEnd = that.queryDataNotice.timeEnd
      data.pageNo = that.page_noNotice
      data.pageSize = that.page_sizeNotice
      data.sortField = that.sortFieldNotice
      data.sortOrder = that.sortOrderNotice
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_NoticeList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataListNotice = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    NoticeNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.noticeType = that.queryDataNotice.noticeType
      data.noticeTitle = that.queryDataNotice.noticeTitle
      data.noticeContent = that.queryDataNotice.noticeContent
      data.timeBegin = that.queryDataNotice.timeBegin
      data.timeEnd = that.queryDataNotice.timeEnd
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_NoticeNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataListNoticenum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
  }
}
</script>

<style lang="less" scoped>
/* ============================================================
 *  TerminalUserManagement · 运动主题设计规范 v1.0
 *  主色: #2563EB (深海蓝)  强调色: #FF6F00 (活力橙)
 * ============================================================ */

.terminal-page {
  width: 100%;
  height: calc(100vh - 88px);
  max-height: calc(100vh - 88px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  --aptus-primary: #2563EB;
  --aptus-primary-light: #3B82F6;
  --aptus-primary-bg: #EFF6FF;
  --aptus-accent: #FF6F00;
  --aptus-accent-bg: #FFF5EB;
  --aptus-success: #2E7D32;
  --aptus-success-bg: #EDF7ED;
  --aptus-danger: #C62828;
  --aptus-danger-bg: #FDECEC;
  --aptus-warning: #F57F17;
  --aptus-surface: #FFFFFF;
  --aptus-surface-muted: #F5F6F8;
  --aptus-border: #E2E6EC;
  --aptus-border-light: #EFF1F5;
  --aptus-text: #1A1D21;
  --aptus-text-secondary: #5E6670;
  --aptus-text-muted: #9AA3B0;
}

.main_r {
  height: 100%;
  padding: 16px 20px 14px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.page-top {
  flex-shrink: 0;
  margin-bottom: 12px;
}

/* 页面标题 */
.title_line {
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 700;
  color: var(--aptus-text);
  display: flex;
  align-items: center;
  gap: 10px;

  &::before {
    content: '';
    width: 4px;
    height: 22px;
    background: linear-gradient(180deg, var(--aptus-primary) 0%, var(--aptus-primary-light) 100%);
    border-radius: 2px;
  }
}

/* 筛选栏 */
.filter-strip {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding: 10px 14px;
  background: var(--aptus-surface);
  border: 1px solid var(--aptus-border);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(15, 26, 46, 0.04);
}

.filter-strip__fields {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px 12px;
  flex: 1;
  min-width: 0;
}

.filter-field--compact {
  gap: 4px;

  /deep/ .el-input,
  /deep/ .el-select,
  /deep/ .el-date-editor {
    width: 100%;
  }
}

.filter-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.filter-field__label {
  font-size: 12px;
  color: var(--aptus-text-secondary);
  font-weight: 500;
  line-height: 1;
  margin-bottom: 4px;
}

.filter-strip__actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;

  /deep/ .el-button {
    margin-left: 0;
  }
}

.filter-strip__sep {
  width: 1px;
  height: 24px;
  background: var(--aptus-border);
  margin: 0 2px;
}

/* 表格区域 */
.table-section {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-top: 12px;
}

.table-container {
  position: relative;
  flex: 1;
  min-height: 0;
  width: 100%;
  background: var(--aptus-surface);
  border-radius: 8px;
  border: 1px solid var(--aptus-border);
  overflow: hidden;
}

/* 用户表格 */
.user-table {
  /deep/ .el-table__body td {
    padding: 12px 0;
    background: var(--aptus-surface);
    border-bottom: 1px solid var(--aptus-border-light);
  }

  /deep/ .el-table__body tr:hover > td {
    background: var(--aptus-primary-bg) !important;
  }

  /deep/ .el-table__header th {
    padding: 12px 0;
    background: var(--aptus-surface-muted) !important;
    border-bottom: 1px solid var(--aptus-border);
    color: var(--aptus-text-secondary);
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  /deep/ .el-table__header th .cell {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    word-break: keep-all;
    line-height: 20px;
    padding: 0 8px;
  }

  /deep/ .el-table__header th .caret-wrapper {
    flex-shrink: 0;
    margin-left: 4px;
    vertical-align: middle;
  }

  /deep/ .el-table__fixed-right-patch {
    background: var(--aptus-surface-muted);
  }

  /deep/ .el-table__fixed-header-wrapper th,
  /deep/ .el-table__fixed .el-table__fixed-header-wrapper th {
    background: var(--aptus-surface-muted) !important;
  }

  /deep/ .el-table__fixed-body-wrapper td {
    background: var(--aptus-surface);
    border-bottom: 1px solid var(--aptus-border-light);
  }

  /deep/ .el-table__fixed-body-wrapper tr:hover > td {
    background: var(--aptus-primary-bg) !important;
  }

  /deep/ thead tr th {
    border-radius: 0 !important;
  }

  /deep/ .el-table-column--selection .cell {
    overflow: visible;
    text-overflow: clip;
  }

  /deep/ .el-table-column--selection .el-checkbox {
    margin-right: 0;
  }
}

/* 操作按钮组 */
.action-group {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  white-space: nowrap;

  .el-link {
    font-size: 15px;
    padding: 4px 5px;
    border-radius: 5px;
    transition: all 200ms ease;
    line-height: 1;

    &:hover {
      background-color: var(--aptus-primary-bg);
    }

    &.el-link--primary:hover {
      background-color: var(--aptus-primary-bg);
    }

    &.el-link--danger:hover {
      background-color: var(--aptus-danger-bg);
    }

    &.el-link--warning:hover {
      background-color: var(--aptus-accent-bg);
    }

    &.el-link--success:hover {
      background-color: var(--aptus-success-bg);
    }
  }
}

/* 分页 */
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--aptus-border);
}

/* 响应式 */
@media (max-width: 1400px) {
  .filter-strip {
    flex-wrap: wrap;
  }

  .filter-strip__fields {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
  }

  .filter-strip__actions {
    width: 100%;
    justify-content: flex-end;
  }
}

@media (max-width: 768px) {
  .main_r {
    padding: 10px;
  }

  .filter-strip__fields {
    grid-template-columns: 1fr 1fr;
  }
}

/* 通用表单 */
.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: var(--aptus-surface-muted);
}

/* 弹窗样式 */
.newAdd /deep/ .el-dialog__footer {
  padding: 16px 24px;
  text-align: right;
  border-top: 1px solid var(--aptus-border-light);
}

.newAdd /deep/ .el-dialog__header {
  padding: 18px 24px;
  background: var(--aptus-surface-muted);
  border-bottom: 1px solid var(--aptus-border-light);
}

.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
  right: 20px;
}

.newAdd /deep/ .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: var(--aptus-text);
}

/* 详情弹窗 */
.detail-dialog /deep/ .el-dialog__body {
  padding: 0;
  max-height: calc(90vh - 120px);
  overflow: hidden;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
  max-height: 65vh;
  overflow-y: auto;
}

.input-unit {
  width: 100px;
  display: inline-block;
  text-align: center;
}

/* 按钮主题覆盖 */
/deep/ .el-button--primary {
  color: #FFF;
  background-color: var(--aptus-primary);
  border-color: var(--aptus-primary);
  font-weight: 500;
  border-radius: 6px;

  &:hover {
    background-color: var(--aptus-primary-light);
    border-color: var(--aptus-primary-light);
    box-shadow: 0 2px 8px rgba(21, 101, 192, 0.25);
  }
}

/deep/ .el-button--primary.is-plain {
  color: var(--aptus-primary);
  background: var(--aptus-primary-bg);
  border-color: #A8D0F5;

  &:hover {
    background: var(--aptus-primary);
    color: #FFF;
    border-color: var(--aptus-primary);
  }
}
</style>

<style scoped>
/* Tabs 样式 */
::v-deep .el-tabs {
  display: flex;
  flex-direction: column;
}

::v-deep .el-tabs__content {
  flex: 1;
  padding: var(--space-2);
  overflow: hidden;
}

::v-deep .el-tab-pane {
  height: 100%;
  display: flex;
  flex-direction: column;
}

::v-deep .el-tabs--border-card {
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-color);
}

::v-deep .el-tabs--border-card > .el-tabs__header {
  background: var(--bg-card);
  border-bottom: 1px solid var(--border-color-light);
}

::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item {
  border: none;
  transition: all var(--transition-fast);
}

::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: var(--primary-color);
  font-weight: 600;
}

::v-deep .el-tabs--border-card > .el-tabs__content {
  padding: var(--space-3);
}
</style>
